import { render, staticRenderFns } from "./belonger-input.vue?vue&type=template&id=35e18b18&scoped=true&"
import script from "./belonger-input.vue?vue&type=script&lang=js&"
export * from "./belonger-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e18b18",
  null
  
)

export default component.exports